import styled from "styled-components";
import {ACTIVE} from "../../../../themes/css-global-classes";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const CommonStyles = styled.a`
    display: flex;
    padding:1rem;
    color: ${props => props.theme.colors.bodyInfo};
`;
const PCBox = styled(CommonStyles)`
    flex-direction: row;
    line-height: 2rem;
    font-size: 1.3rem;
    font-weight: 600;
    text-transform: uppercase;

    ::after{
        height: 20px;
        width: 1px;
        content: "";
        background: ${props => props.theme.colors.bodyInfo};
        margin-left: 4rem;
        margin-right: 1rem;
    }

    &.${ACTIVE}{
      color: ${props => props.theme.colors.filterSelected};
    }
`;
const MobileBox = styled(CommonStyles)`
    flex-direction: column;
    font-size: 1.4rem;
    align-items: center;
    text-align: center;
    padding: 0;

    &.${ACTIVE}{
      color: ${props => props.theme.colors.bodyText};
    }
`;

export const FilterLinkDefaultBox = styledByDevice(PCBox, MobileBox);
